// File: src/components/enum/taskScopeEnum.ts

/**
 * Alcance da tarefa. Os valores são exatamente os que o backend espera
 * (TypeTaskScope).
 */
export enum TypeTaskScope {
    /** Só quem criou enxerga. */
    INDIVIDUAL = 'INDIVIDUAL',
    /** Toda a empresa enxerga. Pode ter responsáveis ou ficar livre. */
    GROUP = 'GROUP',
}

export const TaskScopeLabel: Record<TypeTaskScope, string> = {
    [TypeTaskScope.INDIVIDUAL]: 'Individual',
    [TypeTaskScope.GROUP]: 'Grupo',
};

export const TaskScopeHint: Record<TypeTaskScope, string> = {
    [TypeTaskScope.INDIVIDUAL]: 'Só você vê esta tarefa.',
    [TypeTaskScope.GROUP]:
        'Toda a empresa vê. Sem responsável, fica livre para quem pegar.',
};
